import { GoldFoilTexture } from "@theme/assets";
import { GOLD_FOIL_BOTTOM } from "@theme/themes/ms5/colors";

import type { ThemeUIStyleObject } from "@theme/components";

export default {
  fontFamily: "textSans",
  fontSize: "fs16",
  lineHeight: "lh400",
} as ThemeUIStyleObject;
// Heading elements will pull this by default
export const heading: ThemeUIStyleObject = {
  fontFamily: "brand",
  color: "grey700",
};

// Heading Variants
export const textHeading: ThemeUIStyleObject = {
  fontFamily: "heading",
  fontWeight: "black",
  lineHeight: "lh50",
  letterSpacing: "tight300",
};

// Heading Title
export const headingTitle01: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs28", null, "fs32"],
};

export const headingTitle02: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs32", null, "fs40"],
};

export const headingTitle02Plus: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs32", null, "fs48"],
};

export const headingTitle03: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs40", null, "fs56"],
};

export const headingTitle03Plus: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs40", null, "fs60"],
};

export const headingTitle04: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs48", null, "fs60"],
};

export const headingTitle04Plus: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs48", null, "fs72"],
};

// Heading Display
export const headingDisplay01: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs56", null, "fs80"],
};

export const headingDisplay02: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs56", null, "fs92"],
};

export const headingDisplay02Plus: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs56", null, "fs116"],
};

export const headingDisplay03: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs64", null, "fs116"],
};

export const headingDisplay03Plus: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: ["fs64", null, "fs140"],
};

export const pdpDecorativeHero: ThemeUIStyleObject = {
  variant: "text.textHeading",
  fontSize: "clamp(48px, 17vw, 190px)",
};

// Brand Variants

export const brand: ThemeUIStyleObject = {
  fontFamily: "brand",
  fontWeight: "regular",
  lineHeight: "lh100",
  letterSpacing: "tight200",
};

// Brand Title
export const brandMicro: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: "fs16",
  letterSpacing: "normal",
};

export const brandMicroPlus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs16", null, "fs20"],
  letterSpacing: "normal",
};

export const brandTitle01: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: "fs20",
  letterSpacing: "normal",
};

export const brandTitle01Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs20", null, "fs24"],
  letterSpacing: "normal",
};

export const brandTitle02: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: "fs24",
};

export const brandTitle02Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs24", null, "fs32"],
};

export const brandTitle03: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: "fs32",
  lineHeight: "lh50",
};

export const brandTitle03Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs32", null, "fs40"],
  lineHeight: "lh50",
};

export const brandTitle04: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: "fs44",
  lineHeight: "lh50",
};

export const brandTitle04Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs44", null, "fs48"],
  lineHeight: "lh50",
};

// Brand Display
export const brandDisplay01: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs48", null, "fs60"],
  lineHeight: "lh25",
};

export const brandDisplay01Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs48", null, "fs72"],
  lineHeight: "lh25",
};

export const brandDisplay02: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs60", null, "fs80"],
  lineHeight: "lh25",
};

export const brandDisplay02Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs60", null, "fs92"],
  lineHeight: "lh25",
};

export const brandDisplay03: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs72", null, "fs92"],
  lineHeight: "lh25",
};

export const brandDisplay03Plus: ThemeUIStyleObject = {
  variant: "text.brand",
  fontSize: ["fs72", null, "fs116"],
  lineHeight: "lh25",
};

// Text Sans Variants

export const sansRegular: ThemeUIStyleObject = {
  fontFamily: "textSans",
  fontWeight: "regular",
  lineHeight: "lh300",
  letterSpacing: "tight100",
};

export const sansMedium: ThemeUIStyleObject = {
  fontFamily: "textSans",
  fontWeight: "medium",
  lineHeight: "lh300",
  letterSpacing: "tight100",
};

// Sans Micro
export const sansMicro01Regular: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: "fs10",
};

export const sansMicro01RegularPlus: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: ["fs10", null, "fs12"],
};

export const sansMicro01Medium: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs10",
};

export const sansMicro01MediumPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs10", null, "fs12"],
};

export const sansMicro02Regular: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: "fs12",
};

export const sansMicro02RegularPlus: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: ["fs12", null, "fs14"],
};

export const sansMicro02Medium: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs12",
};

export const sansMicro02MediumPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs12", null, "fs14"],
};

// Sans Body
export const sansBody01Regular: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: "fs14",
  lineHeight: "lh400",
};

export const sansBody01RegularPlus: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: ["fs14", null, "fs16"],
  lineHeight: "lh400",
};

export const sansBody01Medium: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs14",
  lineHeight: "lh400",
};

export const sansBody01MediumTight: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs14",
};

export const sansBody01MediumPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs14", null, "fs16"],
  lineHeight: "lh400",
};

export const sansBody01MediumTightPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs14", null, "fs16"],
};

export const sansBody02Regular: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: "fs16",
  lineHeight: "lh400",
};

export const sansBody02RegularPlus: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: ["fs16", null, "fs18"],
  lineHeight: "lh400",
};

export const sansBody02Medium: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs16",
  lineHeight: "lh400",
};

export const sansBody02MediumTight: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs16",
};

export const sansBody02MediumPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs16", null, "fs18"],
  lineHeight: "lh400",
};

export const sansBody02MediumTightPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs16", null, "fs18"],
};

export const sansBody03Regular: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: ["fs18", null, "fs20"],
};

export const sansBody03RegularPlus: ThemeUIStyleObject = {
  variant: "text.sansRegular",
  fontSize: ["fs18", null, "fs24"],
};

export const sansBody03Medium: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs18", null, "fs20"],
};

export const sansBody03MediumPlus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs18", null, "fs24"],
};

// Sans Title
export const sansTitle01: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs20", null, "fs24"],
};

export const sansTitle01Plus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs20", null, "fs28"],
};

export const sansTitle02: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs24", null, "fs28"],
};

export const sansTitle02Plus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs24", null, "fs30"],
};

export const sansTitle03: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs28", null, "fs32"],
  lineHeight: "lh200",
  letterSpacing: "tight200",
};

export const sansTitle03Plus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs28", null, "fs36"],
  lineHeight: "lh200",
  letterSpacing: "tight200",
};

export const sansTitle04: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs30", null, "fs36"],
  lineHeight: "lh200",
  letterSpacing: "tight200",
};

export const sansTitle04Plus: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs30", null, "fs40"],
  lineHeight: "lh200",
  letterSpacing: "tight200",
};

// Sans Display
export const sansDisplay: ThemeUIStyleObject = {
  fontFamily: "textSans",
  fontWeight: "medium",
  lineHeight: "lh100",
  letterSpacing: "tight300",
};

export const sansDisplay01: ThemeUIStyleObject = {
  variant: "text.sansDisplay",
  fontSize: ["fs36", null, "fs48"],
};

export const sansDisplay01Plus: ThemeUIStyleObject = {
  variant: "text.sansDisplay",
  fontSize: ["fs36", null, "fs56"],
};

export const sansDisplay02: ThemeUIStyleObject = {
  variant: "text.sansDisplay",
  fontSize: ["fs48", null, "fs60"],
};

export const sansDisplay02Plus: ThemeUIStyleObject = {
  variant: "text.sansDisplay",
  fontSize: ["fs48", null, "fs72"],
};

export const sansDisplay03: ThemeUIStyleObject = {
  variant: "text.sansDisplay",
  fontSize: ["fs60", null, "fs92"],
};

export const sansDisplay03Plus: ThemeUIStyleObject = {
  variant: "text.sansDisplay",
  fontSize: ["fs60", null, "fs116"],
};

// Eyebrow
export const eyebrow00: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: "fs12",
  letterSpacing: "loose300",
};

export const eyebrow01: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs12", null, "fs14"],
  letterSpacing: "loose300",
};

export const eyebrow02: ThemeUIStyleObject = {
  variant: "text.sansMedium",
  fontSize: ["fs14", null, "fs16"],
  letterSpacing: "loose300",
};

// Utility
export const utilityLabel: ThemeUIStyleObject = {
  fontFamily: "textSans",
  fontWeight: "regular",
  lineHeight: "lh200",
  letterSpacing: "loose200",
};

export const utilityLabel01Regular: ThemeUIStyleObject = {
  variant: "text.utilityLabel",
  fontSize: "fs10",
};

export const utilityLabel01Medium: ThemeUIStyleObject = {
  variant: "text.utilityLabel",
  fontWeight: "medium",
  fontSize: "fs10",
};

export const utilityLabel02Regular: ThemeUIStyleObject = {
  variant: "text.utilityLabel",
  letterSpacing: "loose300",
  fontSize: "fs10",
};

export const utilityLabelButton: ThemeUIStyleObject = {
  fontFamily: "textSans",
  fontWeight: "semibold",
  lineHeight: "lh100",
  letterSpacing: "tight100",
  fontSize: "fs19",
};

export const saleHeroNumber: ThemeUIStyleObject = {
  fontFamily: "textSans",
  fontWeight: "medium",
  lineHeight: "lh50",
  letterSpacing: "tight500",
  fontSize: [120, null, 205],
};

// Legal Pages
export const legalHeadingLg: ThemeUIStyleObject = {
  ...sansTitle04,
  fontWeight: "bold",
  textTransform: "uppercase",
};

export const legalHeadingMd: ThemeUIStyleObject = {
  ...sansTitle02,
  textTransform: "uppercase",
  fontWeight: "bold",
};

export const legalHeadingSm: ThemeUIStyleObject = {
  ...sansTitle01,
  my: "s200",
  textTransform: "uppercase",
  fontWeight: "bold",
};

export const legalHeadingXs: ThemeUIStyleObject = {
  ...sansBody03Medium,
  textTransform: "uppercase",
  fontWeight: "bold",
};

export const legalTextUppercase: ThemeUIStyleObject = {
  ...sansBody02Medium,
  textTransform: "uppercase",
  fontWeight: "bold",
};

export const legalTextBold: ThemeUIStyleObject = {
  ...sansBody02Medium,
  fontWeight: "bold",
};

export const legalTextBoldSm: ThemeUIStyleObject = {
  ...sansBody01Medium,
  fontWeight: "bold",
};

// Account specific
export const accountLabel: ThemeUIStyleObject = {
  ...sansMicro02Medium,
  display: "block",
  textTransform: "uppercase",
  letterSpacing: "loose200",
};

export const accountDescription: ThemeUIStyleObject = {
  ...sansBody01Regular,
  display: "block",
  color: "grey500",
};

// Buy Box Specific
export const buyBoxFormHeading: ThemeUIStyleObject = {
  ...sansBody01Medium,
  display: "flex",
  lineHeight: "lh100",
  fontVariantNumeric: "tabular-nums",
  span: {
    font: "inherit",
    color: "grey500",
  },
};

// Footer specific
export const footerSectionHeading: ThemeUIStyleObject = {
  ...sansBody03Medium,
  color: "white",
  marginBottom: "s300",
  textAlign: ["center", null, "left"],
};

// Form Specific
export const helperText: ThemeUIStyleObject = {
  ...sansMicro02Regular,
  color: "textLevel3",
  display: "block",
  mt: "s200",
  px: "s400",
};

export const errorText: ThemeUIStyleObject = {
  ...sansMicro02Regular,
  display: "block",
  color: "textError",
  mt: "s200",
  px: "s400",
};

export const successText: ThemeUIStyleObject = {
  ...sansMicro02Regular,
  display: "block",
  color: "textSuccess",
  mt: "s200",
  px: "s400",
};

// Other
const listBullets: ThemeUIStyleObject = {
  listStyle: "none",
  my: "s200",
  ml: "s400",
  p: 0,
  li: {
    ...sansBody02Regular,
    mb: "s100",
    color: "grey400",
    "&::before": {
      content: '"\\2022"',
      color: "goldPrimary",
      fontWeight: "bold",
      display: "inline-block",
      width: "1em",
      ml: "-1em",
    },
  },
};

export const goldBulletLi: ThemeUIStyleObject = {
  listStyleType: "none",
  "&::before": {
    content: '"\\2022"',
    color: "goldPrimary",
    fontWeight: "bold",
    display: "inline-block",
    width: "1em",
    ml: "-1em",
  },
};

export const goldFoil: ThemeUIStyleObject = {
  background: `url("${GoldFoilTexture}") no-repeat top left`,
  backgroundSize: "cover",
  backgroundClip: "border-box",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

export const goldProductGradient: ThemeUIStyleObject = {
  background: `${GOLD_FOIL_BOTTOM}`,
  backgroundSize: "cover",
  backgroundClip: "border-box",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

export const sup: ThemeUIStyleObject = {
  display: "inline-block",
  fontSize: "fs20",
  verticalAlign: "top",
  transform: "translateY(50%)",
};

export const productDescription: ThemeUIStyleObject = {
  mb: "s500",
  p: {
    ...sansBody02Regular,
    color: "textPrimary",
    my: 0,
  },
  h3: {
    ...eyebrow01,
    color: "textBrandLevel2",
    my: 0,
  },
  ul: {
    listStyle: "none",
    ml: "s400",
    my: 0,
    p: 0,
    columns: "1",
    li: {
      ...sansBody02Regular,
      ...goldBulletLi,
      color: "textPrimary",
      mb: "s200",
      pr: "s300",
      "&:last-child": {
        mb: "0",
      },
    },
  },
  "* ~ p": {
    mt: "s200",
  },
  "* ~ h3": {
    mt: ["s300", null, null, "s500"],
  },
  "p + ul": {
    mt: "s300",
  },
  "li > ul": {
    mt: "s200",
  },
  "h3 + ul": {
    mt: "s200",
  },
  "ul + p": {
    mt: "s500",
  },
  strong: { ...sansBody02Medium, py: 0, color: "textPrimary" },
  "> *:last-child": {
    mb: "0",
  },
};

export const msList: ThemeUIStyleObject = {
  ...listBullets,
};

export const screenReaderOnly: ThemeUIStyleObject = {
  position: "absolute",
  width: 1,
  height: 1,
  p: 0,
  m: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  border: 0,
};
